import type { ComponentPropsWithoutRef } from 'react';

import {
  IconClipboardText,
  IconFlask,
  IconMan,
  IconSearch,
  IconShieldLock,
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { FeatureFlag } from '../../../../../shared/entities/FeatureFlags';
import type { SideBarItem } from '../components/SideBarItem';

export function useSideBarLinks(): ComponentPropsWithoutRef<
  typeof SideBarItem
>[] {
  const { t } = useTranslation(['bidResponse']);
  return [
    {
      label: t('menu.vault'),
      icon: <IconShieldLock size={16} />,
      to: '/response/vault/bid-responses',
      activePath: ['/response/vault/*'],
      featureFlag: FeatureFlag.BID_RESPONSE,
    },
    {
      label: t('menu.assistant'),
      icon: <IconMan size={16} />,
      to: '/response/assistant',
      activePath: ['/response/assistant/*'],
      featureFlag: FeatureFlag.BID_RESPONSE,
    },
    {
      label: t('menu.simulation'),
      icon: <IconFlask size={16} />,
      to: '/response/simulation',
      activePath: ['/response/simulation/*'],
      featureFlag: FeatureFlag.BUYER_SIMULATION,
    },
    {
      label: t('menu.project'),
      icon: <IconClipboardText size={16} />,
      to: '/response/projects',
      activePath: ['/response/projects/*'],
      featureFlag: FeatureFlag.PRE_RELEASE,
    },
    {
      label: t('menu.search'),
      icon: <IconSearch size={16} />,
      to: '/response/search/new',
      activePath: ['/response/search/*'],
      featureFlag: FeatureFlag.BID_RESPONSE,
    },
  ];
}
